// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


// serviceUrl: 'https://intelli-nicu.com/api/'
// serviceUrl: 'http://3.109.128.197:8080/api/'
// serviceUrl: 'https://www.inframedtech-d.com/api/'
// serviceUrl: 'http://localhost:8081/api/'
// serviceUrl: 'https://www.inframedtech-d.com/api/'
//local server link =  serviceUrl: 'http://www.inframedtech-d.com:8080/api/'
// new test server url = 'http://43.204.242.179:8080/api/'

export const environment = {
  production: false,
 serviceUrl: 'https://intelli-nicu.com/api/'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */ 
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.